import { render, staticRenderFns } from "./SchoolEnvelopeLabel.vue?vue&type=template&id=05500658&scoped=true"
import script from "./SchoolEnvelopeLabel.vue?vue&type=script&lang=js"
export * from "./SchoolEnvelopeLabel.vue?vue&type=script&lang=js"
import style0 from "./SchoolEnvelopeLabel.vue?vue&type=style&index=0&id=05500658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05500658",
  null
  
)

export default component.exports